import React from "react";

import Feed from "../../components/feed";

const FeedContainer = () => {
  return <Feed />;
};

export default FeedContainer;
